import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import styles from './ActivityBar.module.css';

/**
 * A thin bar along the top edge while any read or write is in flight, so a
 * slow refetch after a save is visibly "still working" rather than stuck.
 * Indeterminate: the bar sweeps rather than fills, and holds still for
 * anyone who asked for reduced motion.
 */
export function ActivityBar() {
  const fetching = useIsFetching();
  const mutating = useIsMutating();
  const busy = fetching + mutating > 0;
  if (!busy) {
    return null;
  }
  return (
    <div className={styles['bar']} role="progressbar" aria-label="Working">
      <div className={styles['sweep']} />
    </div>
  );
}
